// To generate a new file similar to this one, run `pay js:run gql-v1 --type=mutation --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import type {
  V1MutationReturn,
  V1MutationOptions,
  V1MutationOptionsWithoutVariables,
  AccountToken,
} from '@stripe-internal/data-v1/types';
import {gql} from '@sail/data';
import {useV1Mutation} from '@stripe-internal/data-v1';

import type {
  GraphQlDocument,
  GraphQlFragmentUnion,
  HookVariables,
} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiPostV1CryptoInternalPayinSessionConfirmInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';
import {payinSessionFragment} from 'src/api/graphql/payinSessionFragment';

import type {
  PayinSessionFragmentData,
  PayinSessionFragmentToken,
} from 'src/api/graphql/payinSessionFragment';

const doc = gql`
  mutation ConfirmCryptoPurchaseMutation(
    $input: OpenapiPostV1CryptoInternalPayinSessionConfirmInput
    $v1Context: V1ContextInput!
  ) {
    v1CryptoInternalPayinSessionConfirm(input: $input, v1Context: $v1Context) {
      id
      ...PayinSessionFragment
    }
  }
  ${payinSessionFragment}
`;

export const confirmCryptoPurchaseMutation: ConfirmCryptoPurchaseMutationDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const confirmCryptoPurchaseMutationOptions: V1MutationOptionsWithoutVariables<ConfirmCryptoPurchaseMutationDocument> =
  {
    fetchPolicy: 'no-cache',
  };

export default function useConfirmCryptoPurchaseMutation<
  THookVariables extends HookVariables<ConfirmCryptoPurchaseMutationVariables> = {},
>(
  options: V1MutationOptions<
    ConfirmCryptoPurchaseMutationDocument,
    THookVariables
  > = {},
): V1MutationReturn<ConfirmCryptoPurchaseMutationDocument, THookVariables> {
  return useV1Mutation(confirmCryptoPurchaseMutation, {
    ...confirmCryptoPurchaseMutationOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type ConfirmCryptoPurchaseMutationVariables = Exact<{
  input?: InputMaybe<OpenapiPostV1CryptoInternalPayinSessionConfirmInput>;
  v1Context: V1ContextInput;
}>;

export type ConfirmCryptoPurchaseMutationData = {
  readonly __typename: 'Mutation';
  readonly v1CryptoInternalPayinSessionConfirm: GraphQlFragmentUnion<
    {
      readonly __typename: 'OpenapiCryptocurrencyPayinsResourceCryptoPayinSession';
      readonly id: string;
    },
    [PayinSessionFragmentData]
  > | null;
};

export type ConfirmCryptoPurchaseMutationToken = PayinSessionFragmentToken &
  AccountToken<{Mutation_v1CryptoInternalPayinSessionConfirm: true}>;

export type ConfirmCryptoPurchaseMutationDocument = GraphQlDocument<
  ConfirmCryptoPurchaseMutationData,
  ConfirmCryptoPurchaseMutationVariables,
  ConfirmCryptoPurchaseMutationToken
>;
